/**
 * Query-key factory for marketing assets list API.
 *
 *   all
 *   board(boardId)
 *   entity(boardId, entityType, entityId)
 */

export type MarketingAssetEntityType = "task" | "resource" | "client";

/** Maps EntityRecord.entityType (taskId/clientId/resourceId) → API / FileEntityType key. */
export const ENTITY_RECORD_FIELD_TO_API: Record<string, MarketingAssetEntityType> = {
  taskId: "task",
  clientId: "client",
  resourceId: "resource",
};

export const marketingAssetKeys = {
  all: ["marketing-assets"] as const,

  board: (boardId: number) => [...marketingAssetKeys.all, boardId] as const,

  entity: (boardId: number, entityType: MarketingAssetEntityType, entityId: number) =>
    [...marketingAssetKeys.board(boardId), entityType, entityId] as const,
} as const;
